import React, { useEffect, useRef } from "react";
// import { findDOMNode } from "react-dom";
import { Link, withRouter } from "react-router-dom";
import logo from "../../imagenes/logo/logo-nuevo.png";
import misReservas from "../../imagenes/header/mis-reservas.png";
//import logo2x from "../../imagenes/logo/logo-nuevo.png";
//import logo3x from "../../imagenes/logo/logo-nuevo.png";
//import logoNavidad from '../../imagenes/logo/logo-web-navidad.png'
//import logoNavidadx2 from '../../imagenes/logo/logo-web-navidad@2x.jpg'
//import logoNavidadx3 from '../../imagenes/logo/logo-web-navidad@3x.jpg'
import RedesSociales from "./RedesSociales";
import BarraNavegacion from "./BarraNavegacion.js";
// import { reservasAPI } from "../../utils/funcionesAPI";
import { usuariosAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta, traerReservasPorUsuario } from "../../utils/Tools";
import ReactTooltip from "react-tooltip";
import useGlobal from "../../utils/useGlobal";

const Header = (props) => {
  const { location, ocultarBotonValijaYa } = props || {};
  const { pathname = '' } = location || {}
  const token = sessionStorage.getItem("token");
  const { cantidadReservas, setCantidadReservas } = useGlobal();
  const tooltip = useRef(null);

  const handleLogoutClick = () => {
    sessionStorage.clear();
    //  this.props.history.replace('/');
  };

  useEffect(() => {
    traerReservasPorUsuario(props, token, setCantidadReservas);
   
      ReactTooltip.show(tooltip.current);
      setInterval(function() {
        ReactTooltip.hide(tooltip.current);
      }, 5000);
  }, [traerReservasPorUsuario, token]);


  const traerMisDatos = () => {
    if (token) {
      const data = JSON.stringify({ accion: "traerUsuario", token: token });
      usuariosAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          const urlTarifario =
            "http://pedraza.com.ar/tarifarioAgencias/tarifario.php?suc=" +
            respuesta.data.cliente.sucursal;
          window.open(urlTarifario, "_blank");
        }
      });
    }
  };

  let nombreUsuario = sessionStorage.getItem("usuario");
  let tipoCliente = sessionStorage.getItem("tipoCliente");
  //const { tipoCliente = '' } = sessionStorage.getItem('tipoCliente');
  //let usuario = this.props.usuario
  //let usuario = sessionStorage.getItem('usuario');
  //let tipoCliente = sessionStorage.getItem('tipoCliente');
  let usuario = { usuario: nombreUsuario, tipoCliente: tipoCliente };
  if (!usuario.usuario) {
    usuario.usuario = "Iniciar Sesion";
    usuario.tipoCliente = "";
  }

  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        {/* logo */}
        <Link className="navbar-brand" to="/">
          <img
            src={logo}
            style={{ paddingBottom: ".3rem" }}
            alt="Logo de Pedraza Viajes. Al clickearlo, volveremos a la pantalla de inicio"
            
          />
        </Link>

        <div className="navbar-collapse" id="mainNav">
          <ul className="navbar-nav ml-auto mr-auto">
            <li className="nav-item">
              <div
                className="dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="dropdown-toggle" title="Ver Horarios">
                  Buenos Aires <br />
                  <a href="tel: +5401141052100">(011) 4105 2100</a>
                </span>
                <div
                  className="dropdown-menu cuadroHorarios"
                  aria-labelledby="dropdownMenuButton"
                >
                  Atencion Presencial: Lunes a Viernes: de 9:30 a 14:00 y de 15:00 a 18:30 hs. 
                  <br />
                  Atencion telefonica: Lunes a Viernes de 8:00 a 22:00 hs.
                  <br />
                  Sábado, Domingo y Feriados: Solo atención Telefónica de 10:00 a 18:00 Hs.
                </div>
              </div>
            </li>
            <li className="nav-item">
              <div
                className="dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="dropdown-toggle" title="Ver Horarios">
                  Rosario
                  <br />
                  <a href="tel: +08101227337">0810-122-7337</a>
                </span>
                <div
                  className="dropdown-menu cuadroHorarios"
                  aria-labelledby="dropdownMenuButton"
                >
                  Atencion Presencial: Lunes a Viernes: de 9:30 a 14:00 y de 15:00 a 18:30 hs. 
                  <br />
                  Atencion telefonica: Lunes a Viernes de 8:00 a 22:00 hs.
                  <br />
                  Sábado, Domingo y Feriados: Solo atención Telefónica de 10:00 a 18:00 Hs.
                </div>
              </div>
            </li>
            <RedesSociales />
          </ul>
          <div className="dropdown show login">
          {usuario.tipoCliente !== "" && (
            <div className="contenedorReservasActivas">
              <Link to="/panel-mis-reservas">
                <span className="iconoReservasActivas">{cantidadReservas}</span>
                <img src={misReservas} alt="Mis Reservas" width="20" heigth="20" />
                Mis Reservas
                {/* <i className="material-icons suitcase">work</i> */}
              </Link>
             
                
             
            </div>
             )}
            <Link
              className="dropdown-toggle"
              to="/"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
             {/*  <i className="material-icons user">account_circle</i> */}
              <p
                data-tip="Comprá rápido.<br>Iniciá sesión o registrate."
                ref={tooltip}
                data-class="tooltipEstilo"
              >
                {usuario.usuario}
              </p>
            </Link>
            <div style={{width: '100%', minWidth: '0'}} className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {usuario.tipoCliente === "" ? (
                <Link className="dropdown-item" style={{padding: '0.25rem 1rem'}} to="/login">
                  Acceso
                </Link>
              ) : null}
              {usuario.tipoCliente === "" ? (
                <Link className="dropdown-item" to="/registracion" style={{padding: '0.25rem 1rem'}}>
                  Registrar
                </Link>
              ) : null}
             {/*  {usuario.tipoCliente === "AGE" && (
                <Link className="dropdown-item" style={{padding: '0.25rem 1rem'}} to="/" onClick={traerMisDatos}>
                  Tarifario
                </Link>
              )} */}
              {usuario.tipoCliente !== "" ? (
                <Link className="dropdown-item" style={{padding: '0.25rem 1rem'}} to="/panel-mis-reservas">
                  Mis Reservas
                </Link>
              ) : null}
              {usuario.tipoCliente !== "" ? (
                <Link className="dropdown-item"style={{padding: '0.25rem 1rem'}}  to="/mi-perfil">
                  Mi Perfil
                </Link>
              ) : null}
              {usuario.tipoCliente !== "" ? (
                <Link
                  className="dropdown-item"
                  style={{padding: '0.25rem 1rem'}}
                  to="/"
                  onClick={handleLogoutClick}
                >
                  Cerrar Sesi&oacute;n
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </nav>
      <BarraNavegacion origen={props.origen} isCDR={pathname.includes('/hoteles')} ocultarBotonValijaYa={ocultarBotonValijaYa} />
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="solid"
        multiline={true}
      />
    </header>
  );
};

export default withRouter(Header);




// WEBPACK FOOTER //
// ./src/components/Global/Header.js